import React, { useState } from "react";

const PasswordToggle = ({
  id,
  name,
  placeholder,
  btnClass,
  onInputChange,
  cvv,
  required,
  urlCarrier,
}) => {
  // State to track password and visibility
  const [showPassword, setShowPassword] = useState(false);

  // Function to toggle password visibility
  const togglePassword = () => {
    setShowPassword(!showPassword);
  };
  // Handle the input change and call the function from PageA
  const handleChange = (event) => {
    //const newValue = event.target.value;
    onInputChange(event); // Call the function passed from MakePayment
  };

  // Determine eye toggle classes based on carrier
  const isBcbsaz = urlCarrier?.toLowerCase() === 'bcbsaz';
  const eyeToggleClass = showPassword 
    ? (isBcbsaz ? "fe-eye-toggle-bcbsaz" : "fe-eye-toggle")
    : (isBcbsaz ? "fe-eye-toggle-off-bcbsaz" : "fe-eye-toggle-off");

  return (
    <>
      <input
        type={showPassword ? "text" : "password"}
        className={`form-control ${btnClass}`}
        id={id}
        name={name}
        value={cvv}
        onChange={handleChange}
        placeholder={placeholder}
        data-role="togglepassword"
        required={required}
      />

      <button
        type="button"
        className={`btn-passwordbtn ${btnClass}`}
        onClick={togglePassword}
        data-role="togglepassword"
        title={showPassword ? "Hide password" : "Show password"}
        tabIndex="-1"
      >
        <i className={eyeToggleClass}></i>
      </button>
    </>
  );
};

export default PasswordToggle;
